import React, { CSSProperties } from 'react'

import styled from '@emotion/styled'

import { component as arcadeComponentColors, semantic as arcadeSemanticColors } from '@arcade/web'

import { typography } from '../../theme'
import { ArcadeColors, ComponentColors } from '../../theme/arcadeColors'
import { SemanticColors } from '../../theme/arcadeColors'

const isSemanticColor = (color: string): color is SemanticColors => {
  return color in arcadeSemanticColors
}

const isArcadeComponentColor = (color: string): color is ComponentColors => {
  return color in arcadeComponentColors
}

const TextBase = styled.span<{
  themeColor?: ArcadeColors
  typography?: keyof typeof typography
  textAlign?: CSSProperties['textAlign']
  // CSSProperties does not yet include textWrap so we have to manually add the type.
  textWrap?:
    | 'wrap'
    | 'nowrap'
    | 'balance'
    | 'pretty'
    | 'stable'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset'
}>`
  ${({ theme, themeColor }) => {
    if (!themeColor) return ''

    if (isSemanticColor(themeColor)) {
      return `color: ${theme.arcadeColors.semantic[themeColor]};`
    }
    if (isArcadeComponentColor(themeColor)) {
      return `color: ${theme.arcadeColors.component[themeColor]};`
    }

    return ''
  }}
  ${({ theme, typography }) => (typography ? theme.typography[typography] : '')}
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign};` : '')}
  ${({ textWrap }) => (textWrap ? `text-wrap: ${textWrap};` : '')}
`

// Wraps the TextBase since if we pass a `color` attribute directly to a styled component
// it will show up as an attribute in the DOM.
const Text = ({
  color,
  ...rest
}: Omit<React.ComponentProps<typeof TextBase>, 'themeColor'> & {
  color?: React.ComponentProps<typeof TextBase>['themeColor']
}) => {
  return <TextBase themeColor={color} {...rest} />
}

export default Text
